import {
  Component,
  Input,
  ChangeDetectorRef,
  OnInit,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ChangeDetectionStrategy,
  AfterViewInit,
  AfterContentInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { StateCustomPanelVehicleService } from '../../service/state-custom-panel-vehicle.service';
import { FollowService } from 'src/app/vehicles/services/follow.service';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { MapService } from 'src/app/vehicles/services/map.service';
import { iconMap } from '../../static/icons-vehicles.static';
import { VehicleEyeStateService } from '../../service/vehicle-eye-state.service';
import { Subject } from 'rxjs';
import {
  takeUntil,
  map,
  distinctUntilChanged,
  finalize,
  debounceTime,
  filter,
  tap,
} from 'rxjs/operators';
import { UpdateNameUnitService } from '../../service/update-name-unit.service';
import {
  UpdateUnitNameRequest,
  UpdateUnitNameResponse,
} from '../../models/update-unit-name.model';
import { Subscription } from 'rxjs';
import {
  DetailState,
  ViewOptionState,
} from '../../models/vehicle-state-local.model';
import { UnitCollectionService } from '../../service/unit-collection.service';
import {
  BroadcastService,
  CommandPayload,
} from 'src/app/broadcast/service/broadcast.service';
import Swal from 'sweetalert2';
import { UsersService } from 'src/app/dashboard/service/users.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-card-vehicle',
  templateUrl: './card-vehicle.component.html',
  styleUrls: ['./card-vehicle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardVehicleComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @Input() idCard = 'default';
  @Input() primaryName = '';
  @Input() IMEI = ''; // as IMEI
  @Input() date: Date | null = null;
  @Input() location = '';
  @Input() transmissionStatus = 0;
  @Input() speed: { value: number; measurement: string } = {
    value: 0,
    measurement: '',
  };
  @Input() batteryVoltage: { value: number; measurement: string } = {
    value: 0,
    measurement: '',
  };
  @Input() amountOfFuel: { value: number; measurement: string } = {
    value: 0,
    measurement: '',
  };
  @Input() timeElapsed = '';
  @Input() hasIgnition = false;
  @Input() satelliteCount = 0;
  @Input() temperatureBLE: {
    value: number;
    variant: 'disabled' | 'hot' | 'medium' | 'cold';
    typeGps: string;
  } = { value: 0, variant: 'disabled', typeGps: '' };
  @Input() temperatureEYE: {
    value: number;
    variant: 'disabled' | 'hot' | 'medium' | 'cold';
    typeGps: string;
  } = { value: 0, variant: 'disabled', typeGps: '' };

  @Input() humidityBLE: {
    value: number;
    variant: 'disabled';
    typeGps: string;
  } = { value: 0, variant: 'disabled', typeGps: '' };

  @Input() humidityEYE: {
    value: number;
    variant: 'disabled';
    typeGps: string;
  } = { value: 0, variant: 'disabled', typeGps: '' };

  @Input() secondInformation = '';
  @Input() unitType = '';
  @Input() urlIcon: any = '';
  @Input() unitDetails: {
    label: string;
    value: string;
    variant: 'default' | 'edit';
  }[] = [];
  @Input() iosDetail: {
    label: string;
    value: string;
    variant: 'default' | 'edit';
  }[] = [];

  @Input() isExpanded = false;
  @Output() toggleExpanded = new EventEmitter<void>();
  @Input() viewOptionVisible = true;
  @Output() toggleVisible = new EventEmitter<void>();
  @Output() setTrueVisible = new EventEmitter<void>();
  @Input() viewOptionFollow = false;
  @Output() toggleFollow = new EventEmitter<void>();
  @Input() viewOptionShowDriver = false;
  @Output() toggleShowDriver = new EventEmitter<void>();
  @Input() viewOptionShowName = true;
  @Output() toggleShowName = new EventEmitter<void>();

  @Input() withOpenClose: boolean = true;
  @Input() withActionButton: boolean = true;

  /*
  @Input() details: DetailState = {
    firstSectionOpen: false,
    secondSectionOpen: true,
  };
  @Output() toggleExpandedFirstSection = new EventEmitter<void>();
  @Output() toggleExpandedSecondSection = new EventEmitter<void>();
  */

  private isShowEye = false;
  public variantTab = 'undefined';
  public isShowDriver = false;
  public isShowTagUnit = true;
  public isFollowUnit = false;
  private vehicleOld: any = null;
  public isShowTooltipEdit = false;
  public isShowTooltipFollow = false;
  public isShowTooltipTag = false;
  public isShowTooltipDriver = false;
  public isShowTooltipEye = false;
  public isShowTooltipHistory = false;
  public isShowTooltipCommand = false;
  public isCopyIMEI = false;
  public isCopyLocation = false;
  public isLoading = true;
  private destroy$ = new Subject<void>();
  public isObserverCard = false;

  private eyeStateSub?: Subscription;
  private flagEyeTooltip = false;
  private _user: { userName: string; userId: string } | undefined = undefined;
  private _password: string | undefined;

  constructor(
    public servicePanel: StateCustomPanelVehicleService,
    private followService: FollowService,
    private vehicleService: VehicleService,
    private mapService: MapService,
    private cdr: ChangeDetectorRef,
    private vehicleEyeStateService: VehicleEyeStateService,
    private updateNameUnitService: UpdateNameUnitService,
    private unitCollectionService: UnitCollectionService,
    private broadcastService: BroadcastService,
    private usersService: UsersService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.vehicleOld) {
      this.loadVehicle();
    }

    if (this.vehicleOld) {
      this.isLoading = false;
      this.cdr.detectChanges();
    }

    if (changes['transmissionStatus']) {
      this.variantTab = this.getVariantTab(this.transmissionStatus);
      this.cdr.detectChanges();
    }
    // corrector de error de icono
    /* if (changes['urlIcon']) {
      if (!this.urlIcon) {
        this.setUrlIcon();
        this.cdr.detectChanges();
      }
    } */
  }

  ngOnInit(): void {
    this.location = this.location || 'No disponible';
    this.variantTab = this.getVariantTab(this.transmissionStatus);
    this.loadVehicle();
    if (!this.urlIcon) {
      this.setUrlIcon();
    }
    this.initEyeStateSubscription();
    this.usersService
      .getAll()
      .pipe(
        tap((T: any) => {
          this._user = {
            userName:
              T?.data?.nombre_usuario ||
              localStorage.getItem('user_id') ||
              'unknown',
            userId: T?.data?.id || localStorage.getItem('user_id') || 'unknown',
          };
          this.broadcastService.setUser = this._user;
          this.broadcastService.setPassword = T?.data?.passwordCommandSubmit;
          this._password = T?.data?.passwordCommandSubmit || environment.pwd;
        }),
      )
      .subscribe();
  }

  ngAfterViewInit(): void {
    // Usamos setTimeout para asegurarnos que el DOM esté completamente renderizado
    setTimeout(() => {
      this.setUpObserverCard();
    });
  }

  private elementCard?: HTMLElement;
  private observer?: IntersectionObserver;

  private setUpObserverCard() {
    // Función recursiva para intentar obtener el elemento
    const tryGetElement = () => {
      const card = document.getElementById(this.idCard);
      if (card) {
        this.elementCard = card;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.isObserverCard = true;
              } else {
                this.isObserverCard = false;
              }
              this.cdr.detectChanges();
            });
          },
          {
            threshold: 0,
          },
        );

        this.observer.observe(card);
      } else {
        setTimeout(tryGetElement, 100);
      }
    };

    tryGetElement();
  }

  private initEyeStateSubscription(): void {
    if (!this.IMEI) return;

    // Cancelar suscripción anterior si existe
    if (this.eyeStateSub) {
      this.eyeStateSub.unsubscribe();
    }

    // Estado inicial
    this.isShowEye = this.vehicleEyeStateService.getVehicleState(this.IMEI);
    this.cdr.detectChanges();

    this.eyeStateSub = this.vehicleEyeStateService.eyeState$
      .pipe(
        takeUntil(this.destroy$),
        debounceTime(100),
        map((state) => {
          if (!state) return null;
          return {
            isImeiIncluded: state.imeis.includes(this.IMEI!.toString()),
            show: state.show,
          };
        }),
        filter((state) => state !== null),
        distinctUntilChanged(
          (prev, curr) =>
            prev!.isImeiIncluded === curr!.isImeiIncluded &&
            prev!.show === curr!.show,
        ),
      )
      .subscribe((state) => {
        if (state!.isImeiIncluded) {
          this.isShowEye = !state!.show;
          this.cdr.detectChanges();
        }
      });
  }

  private cleanupEyeStateSubscription(): void {
    if (this.eyeStateSub) {
      this.eyeStateSub.unsubscribe();
      this.eyeStateSub = undefined;
    }
  }

  private setUrlIcon(): void {
    switch (this.unitType.toLowerCase()) {
      case 'bus':
        this.urlIcon = iconMap.get('bus');
        break;
      case 'minibus':
        this.urlIcon = iconMap.get('minibus');
        break;
      default:
        this.urlIcon = iconMap.get('minibus');
        break;
    }
  }

  private loadVehicle(): void {
    if (!this.IMEI || this.vehicleOld) return;

    this.vehicleOld = this.vehicleService.getVehicle(this.IMEI);
    if (this.vehicleOld) {
      this.isFollowUnit = !!this.vehicleOld.follow;
      this.cdr.detectChanges();
    }
  }

  private updateVehicle(): void {
    const vehicle = this.vehicleService.getVehicle(this.IMEI);
    this.vehicleOld = vehicle;
  }

  getVariantTab(id: number): string {
    const variants: { [key: number]: string } = {
      1: 'inMotion',
      2: 'idleWithIgnitionOn',
      3: 'idleWithoutIgnition',
      4: 'noTransmission',
      5: 'noSignalCoverage',
      6: 'gpsError',
    };
    return variants[id] || 'undefined';
  }

  toggleCardVisibility(event: Event): void {
    event?.stopPropagation();

    this.toggleExpanded.emit();
  }

  stopEvent(event: Event): void {
    event.stopPropagation();
  }

  onClickEye(): void {
    if (!this.vehicleOld) return;

    // auxiliar para la funcionalidad vista por UNIDAD
    this.updateVehicle();

    this.vehicleEyeStateService.updateVehicleState(
      this.IMEI.toString(),
      this.isShowEye,
    );

    const isFilterEyeActive = this.unitCollectionService.getStateFilterEye();
    if (isFilterEyeActive && !this.isShowEye) {
      this.isShowTooltipEye = false;
      this.flagEyeTooltip = true;
    }

    this.toggleVisible.emit();
    this.isShowEye = !this.isShowEye; // aqui pasa la magia
    this.vehicleService.onClickEye(this.IMEI.toString());
    /* if (!this.isShowEye) {
      setTimeout(() => {
        this.auxShowNameUnit();
      });
    } */
    this.flagEyeTooltip = false;
    this.cdr.markForCheck();
  }

  /*   auxShowNameUnit() {
    if (this.servicePanel.getShowNameItemButton()) {
      this.mapService.changeNameVehicles('Nombre');
    } else if (this.servicePanel.getShowInternalCodeItemButton()) {
      this.mapService.changeNameVehicles('cod_interno');
    } else if (this.servicePanel.getShowNamePlateItemButton()) {
      this.mapService.changeNameVehicles('num_plate');
    }
  } */

  onClickFollow(event?: Event): void {
    event?.stopPropagation();
    if (!this.vehicleOld || Object.keys(this.vehicleOld).length === 0) {
      console.error(
        'BUG NUEVO!!!, se necesita recargar la pagina. Posiblemente no cargo el servicio de vehículo antiguo',
      );
      return;
    }

    // auxiliar para la funcionalidad vista por UNIDAD
    this.updateVehicle();

    if (this.vehicleOld) {
      this.toggleFollow.emit();
      this.isFollowUnit = !this.isFollowUnit;
      this.vehicleOld.follow = this.isFollowUnit;
      this.mapService.setFollowVehicle(this.vehicleOld);
      this.followService.add(this.vehicleOld);
      /* setTimeout(() => {
        this.auxShowNameUnit();
      }); */
      this.cdr.detectChanges();
    }
  }

  onClickTag(): void {
    if (!this.vehicleOld) return;

    // auxiliar para la funcionalidad vista por UNIDAD
    this.updateVehicle();

    if (this.vehicleOld) {
      this.toggleShowName.emit();
      this.isShowTagUnit = !this.isShowTagUnit;
      this.mapService.setTag(this.vehicleOld);
      this.mapService.tagClick(this.vehicleOld);
      this.cdr.detectChanges();
    }
  }

  onClickShowDriver(): void {
    if (!this.vehicleOld) return;
    // auxiliar para la funcionalidad vista por UNIDAD
    this.updateVehicle();
    if (this.vehicleOld) {
      this.toggleShowDriver.emit();
      this.isShowDriver = !this.isShowDriver;
      this.mapService.tagDriver(this.vehicleOld);
      /* setTimeout(() => {
        this.auxShowNameUnit();
      }); */
      this.cdr.detectChanges();
    }
  }

  onClickShowHistory(): void {
    if (!this.vehicleOld) return;
    this.mapService.onClickHistoryButton.emit({
      is_custom: false,
      imei: this.IMEI,
    });
  }
  onClickEmmitCommand(e: any, v: any): void {
    if (!this.vehicleOld) return;
    // this.mapService.onClickCommandButton.emit({
    //   is_custom: false,
    //   imei: this.IMEI,
    // });
    console.log('--------------Saints', {
      is_custom: false,
      imei: this.IMEI,
      e,
      v,
    });
    const plate = Array.isArray(v)
      ? v.find((_) => _.label == 'Placa')?.value
      : '-';

    Swal.fire({
      title: 'Confirma el envío del comando',
      text: 'Ingresa tu contraseña para autorizar el envío del comando al dispositivo de seguridad vehicular.',
      input: 'password',
      inputPlaceholder: 'Ingresa tu contraseña',
      inputAttributes: { autocapitalize: 'off' },
      showCancelButton: true,
      confirmButtonText: 'Autorizar y enviar',
      showLoaderOnConfirm: true,
      preConfirm: async (login) => {
        try {
          const response = login == this._password;
          if (!response)
            return Swal.showValidationMessage('contrasena invalida');
          return response;
        } catch (error) {
          Swal.showValidationMessage(`
            Request failed: ${error}
          `);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed)
        this.sendCommandToUnits({
          device_id: this.IMEI,
          unit: plate,
          user_id: this._user?.userId || '-',
          user_name: this._user?.userName || '-',
          type: e.type || '-',
          payload: e.value || '-',
        });
    });
  }
  private sendCommandToUnits(cmd: CommandPayload) {
    this.broadcastService.sentCommands([cmd]);
  }

  onClickCard(event: Event): void {
    event?.stopPropagation();
    this.vehicleService.onClickIcon(this.IMEI.toString());
    this.setTrueVisible.emit();
    if (this.isShowEye) {
      this.vehicleEyeStateService.updateVehicleState(
        this.IMEI.toString(),
        this.isShowEye,
      );
      this.isShowEye = false;
      /* setTimeout(() => {
        this.auxShowNameUnit();
      }); */
    }
    // console.log('CARD CLICKED: ', this.IMEI);
  }

  copyValueIMEI(event: Event): void {
    event.stopPropagation();
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(this.IMEI)
        .then(() => {
          this.isCopyIMEI = true;
          this.cdr.detectChanges();
          setTimeout(() => {
            this.isCopyIMEI = false;
            this.cdr.detectChanges();
          }, 500);
        })
        .catch((err) => {
          console.error('Error al copiar al portapapeles: ', err);
        });
    } else {
      console.warn('El portapapeles no está soportado en este navegador');
    }
  }

  hideTooltipIMEI(): void {
    this.isCopyIMEI = false;
    this.cdr.detectChanges();
  }

  copiedField: 'primaryName' | 'IMEI' | null = null;

  copyToClipboard(value: string, field: 'primaryName' | 'IMEI'): void {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        this.copiedField = field;
        setTimeout(() => {
          this.copiedField = null;
        }, 2000);
      })
      .catch((err) => {
        console.error('Error al copiar al portapapeles:', err);
      });
  }

  copyDateText(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const text = target.innerText;
    navigator.clipboard.writeText(text).then(() => {
      console.log('Fecha copiada:', text);
      // Opcional: mostrar feedback visual
    });
  }

  copyValueLocation(event: Event): void {
    if (this.location === 'No disponible') return;
    event.stopPropagation();
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(this.location)
        .then(() => {
          this.isCopyLocation = true;
          this.cdr.detectChanges();
          setTimeout(() => {
            this.isCopyLocation = false;
            this.cdr.detectChanges();
          }, 500);
        })
        .catch((err) => {
          console.error('Error al copiar al portapapeles: ', err);
        });
    } else {
      console.warn('El portapapeles no está soportado en este navegador');
    }
  }

  hideTooltipLocation(): void {
    this.isCopyLocation = false;
    this.cdr.detectChanges();
  }

  onMouseEnter(type: string): void {
    switch (type) {
      case 'edit':
        this.isShowTooltipEdit = true;
        break;
      case 'follow':
        this.isShowTooltipFollow = true;
        break;
      case 'tag':
        this.isShowTooltipTag = true;
        break;
      case 'driver':
        this.isShowTooltipDriver = true;
        break;
      case 'eye':
        if (this.flagEyeTooltip) {
          this.flagEyeTooltip = false;
          break;
        }
        this.isShowTooltipEye = true;
        break;
      case 'history':
        this.isShowTooltipHistory = true;
        break;
      case 'command':
        this.isShowTooltipCommand = true;
        break;
      default:
        break;
    }
  }

  onMouseLeave(type: string): void {
    switch (type) {
      case 'edit':
        this.isShowTooltipEdit = false;
        break;
      case 'follow':
        this.isShowTooltipFollow = false;
        break;
      case 'tag':
        this.isShowTooltipTag = false;
        break;
      case 'driver':
        this.isShowTooltipDriver = false;
        break;
      case 'eye':
        this.isShowTooltipEye = false;
        break;
      case 'history':
        this.isShowTooltipHistory = false;
        break;
      case 'command':
        this.isShowTooltipCommand = false;
        break;
      default:
        break;
    }
  }

  private updateNameSubscription?: Subscription;

  updateNameUnit(newName: string): void {
    if (!newName?.trim()) return;

    // Cancelar suscripción anterior si existe
    this.cleanupUpdateNameSubscription();

    const request: UpdateUnitNameRequest = {
      unitImei: this.IMEI,
      newName: newName.trim(),
    };

    this.updateNameSubscription = this.updateNameUnitService
      .updateUnitName(request)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.cdr.markForCheck()),
      )
      .subscribe({
        next: (response: UpdateUnitNameResponse) => {
          if (response.success) {
            this.primaryName = newName;
          } else {
            console.error('Error al actualizar el nombre', response.message);
          }
        },
        error: (error) => console.error('Error en la petición', error),
      });
  }

  private cleanupUpdateNameSubscription(): void {
    if (this.updateNameSubscription) {
      this.updateNameSubscription.unsubscribe();
      this.updateNameSubscription = undefined;
    }
  }

  ngOnDestroy(): void {
    if (this.observer && this.elementCard) {
      this.observer.unobserve(this.elementCard);
    }
    this.cleanupEyeStateSubscription();
    this.cleanupUpdateNameSubscription();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
